import React, { useState, useEffect } from 'react';
import { StyleSheet, Text, View, Vibration,BackHandler } from 'react-native';
import { Camera } from 'expo-camera';
import { BarCodeScanner } from 'expo-barcode-scanner';
import { useNavigation } from '@react-navigation/native';


export default function App1() {
  const [hasPermission, setHasPermission] = useState(true);
  const navigation = useNavigation();
  const [scanned, setScanned] = useState(false);


  useEffect(() => {
    (async () => {
      setHasPermission(true);
    })();

    const backAction = () => {
      navigation.navigate('ListadoUPCS');
      return true;
    };

    const backHandler = BackHandler.addEventListener('hardwareBackPress', backAction);

    
    return () => backHandler.remove();
  }, []);

  function irMenuUpc(navigation,upc,invT,invE,invB,descripcionUpc,comentarios){

    gUpc = upc;
    gInvt = invT;
    gInve = invE;
    gInvb = invB;
    gComentarios = comentarios;
    gDescripcionUpc =descripcionUpc;
    if(global.gTipoCapInv == true){
    
      global.gLotescapturados = {
        HeadTable1: ['Inventarios capturados'],
        HeadTable2: ['Lote', 'Caducidad', 'Exhibido', 'Bodega','Total'],
        DataTable1: [
  
          ['', '', '', '',''],
          ['', '', '', '','']
  
        ]
    
      }
      global.gLote = "";
      navigation.navigate('UPCLote');
  
    }else{
  
      navigation.navigate('UPC');
  
    }
  
  
  }


  const handleBarCodeScanned = (event) => {
    
    Vibration.vibrate(100);

    var entro = 0;
    var upc = "";
    var inv_teorico = "";
    var inv_exhibido = "";
    var inv_bodega = "";
    var descripcion = "";
    var comentarios = "";
 
    global.upcs.forEach(upcs => {

      (upcs.upc );
      //console.log(event.data );
      if(upcs.upc.substring(0,upcs.upc.length) == event.data.substring(0,event.data.trim().length) || upcs.upc.substring(0,upcs.upc.trim().length-1) == event.data.trim().substring(0,event.data.trim().length)){
       // console.log(entro);
        entro = 1;
        upc = upcs.upc;
        inv_teorico = upcs.inv_teorico;
        inv_exhibido = upcs.inv_exhibido;
        inv_bodega = upcs.inv_bodega;
        descripcion = upcs.descripcion;
        var comentarios = upcs.comentarios;

        setScanned(true);
       
      }

     
      });

      if (entro ==1){

        //console.log(upcs);

        irMenuUpc(navigation,upc,inv_teorico,inv_exhibido,inv_bodega,descripcion,comentarios);
       
      }else{

        alert("Producto no encontrado",null,2);
        navigation.navigate('ListadoUPCS');

      }
   

  };

 

  if (hasPermission === null) {
    return <Text>Requesting permissions...</Text>;
  }

  if (hasPermission === false) {
    return <Text>No access to camera</Text>;
  }

  return (
    <View style={styles.container}>
      <Camera

       style={styles.camera}  
        
        ratio={'16:9'}
        type={Camera.Constants.Type.back}
        focusDepth={1}
        
        zoom={0.2}
        cameraViewDimensions={{
          width: 10,
          height: 10,
      }}
       
        onBarCodeScanned={scanned ? undefined :handleBarCodeScanned}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  camera: {
    
    height: "50%",
    width: "100%",
  },
});
